import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

class SubnavWrapper extends React.Component {
  static propTypes = {
    isFullscreen: PropTypes.bool,
    kiosk: PropTypes.bool,
  }

  containerClass() {
    // Boostrap container class, change to fluid on fullscreen
    return (this.props.isFullscreen || this.props.kiosk) ? 'container-fluid' : 'container'
  }

  render() {
    return (
      <>
        <div id="subnav-block" className="admin-guide-edit-nav">
          <div className={this.containerClass()}>
            <div className="row">
              {this.props.children}
            </div>
          </div>
        </div>
        <div className='clearfix visible-sm-block visible-xs-block'></div>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isFullscreen: state.view.fullscreen,
    kiosk: state.browsing.kiosk,
  }
}

export default connect(mapStateToProps)(SubnavWrapper)
